export default __webpack_public_path__ + "static/blablacar-logo.a063e644.svg";